var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJpeg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EAEDF4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 32,
    height: 15,
    rx: 2,
    fill: "#0F91AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74 16V17.05H10.71V20.86C10.71 21.77 10.05 22.04 9.21 22.04C8.64 22.04 8.07 21.89 7.65 21.62V22.71C8.1 22.96 8.76 23.12 9.45 23.12C10.76 23.12 11.85 22.51 11.85 20.96V16H8.74ZM13.4867 16V23H14.6267V20.6H15.9867C17.6467 20.6 18.9767 20.08 18.9767 18.3C18.9767 16.52 17.6467 16 15.9867 16H13.4867ZM17.8167 18.3C17.8167 19.32 17.0067 19.56 16.0467 19.56H14.6267V17.04H16.0467C17.0167 17.04 17.8167 17.28 17.8167 18.3ZM20.1176 16V23H24.9976V21.96H21.2576V19.99H24.6376V18.95H21.2576V17.04H24.9376V16H20.1176ZM25.7911 19.5C25.7911 22.11 27.6711 23.13 29.6111 23.13C30.3811 23.13 31.1711 22.96 31.8411 22.66V19.24H30.7311V21.89C30.4511 22.02 30.0711 22.09 29.6811 22.09C28.4111 22.09 26.9611 21.5 26.9611 19.5C26.9611 17.67 28.3411 16.92 29.7111 16.92C30.4311 16.92 31.1411 17.1 31.6711 17.44V16.33C31.0411 16.03 30.3011 15.87 29.5511 15.87C27.6711 15.87 25.7911 17.03 25.7911 19.5Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpeg);
export default __webpack_public_path__ + "static/media/jpeg.413336fcf83d9d015b22b637d5b14ca3.svg";
export { ForwardRef as ReactComponent };